// get employeee list for admin workforce
export const GET_EMPLOYEE_List = "get_employee_list";
export const GET_EMPLOYEE_List_SUCCESS = "get_employee_list_success";
export const GET_EMPLOYEE_List_FAILURE = "get_employee_list_failure";
export const RESET_EMPLOYEE_List = "reset_employee_list";
